<template lang="pug">
  .advertisement(v-if="advertisement")
    .advertisement__border.advertisement__border--top
    .advertisement__border.advertisement__border--right
    .advertisement__border.advertisement__border--bottom
    .advertisement__border.advertisement__border--left
    .advertisement__corner.advertisement__corner--tl
    .advertisement__corner.advertisement__corner--tr
    .advertisement__corner.advertisement__corner--bl
    .advertisement__corner.advertisement__corner--br
    .advertisement__decor-top
    .advertisement__decor-bottom
    .advertisement__title(v-if="h1") {{h1}}
    .advertisement__content
      .advertisement__items(v-if="advertisementItems && advertisementItems.items")
        router-link.advertisement__item(v-for="item in advertisementItems.items", :key="item.id", :to="item.link")
          .advertisement__item-img-wr(:data-src="item.img")
            .advertisement__item-img-overlay
              SvgIcon(name="search" width="32" height="32" class="advertisement__item-img-overlay-ico")
              .advertisement__item-img-overlay-text Смотреть
            img.advertisement__item-img.advertisement__item-img--hide(:src="item.img")
          .advertisement__item-title(v-if="item.title") {{item.title}}
          .advertisement__item-date(v-if="item.date") {{item.date}}
      button.advertisement__items-more(v-if="more", @click="loadMoreItems")
        SvgIcon(name="recycle" width="25" height="25" class="advertisement__items-more-loader")
        SvgIcon(name="arrow-down" width="12" height="7" class="advertisement__items-more-ico")
        .advertisement__items-more-text Еще...
    .advertisement__card
      .advertisement__border.advertisement__border--right
      .advertisement__card-preloader
        .advertisement__border.advertisement__border--right
        .advertisement__card-preloader-img
          .advertisement__card-preloader-img-color-wr
            .advertisement__card-preloader-img-color
      .advertisement__card-decor-top
      .advertisement__card-decor-bottom
      .advertisement__card-title(v-if="h1") {{h1}}
      button.advertisement__card-back(v-if="advertisementItem && advertisementItem.backText", @click="goBack")
        SvgIcon(name="back" width="7" height="12" class="advertisement__card-back-ico")
        | {{advertisementItem.backText}}
      .advertisement__card-content
        .advertisement__card-img-wr(v-if="advertisementItem && advertisementItem.img", :data-src="advertisementItem.img")
          img.advertisement__card-img.advertisement__card-img--hide(:src="advertisementItem.img")
        .advertisement__card-date(v-if="advertisementItem && advertisementItem.date") {{advertisementItem.date}}
        .advertisement__card-name(v-if="advertisementItem && advertisementItem.name") {{advertisementItem.name}}
        .advertisement__card-time(v-if="advertisementItem && advertisementItem.time")
          span Время:&nbsp;
          |{{advertisementItem.time}}
        .advertisement__card-address(v-if="advertisementItem && advertisementItem.address")
          span Адрес:&nbsp;
          | {{advertisementItem.address}}
        .advertisement__card-text(v-if="advertisementItem && advertisementItem.text", v-html="advertisementItem.text")

</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/advertisement/advertisement.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

export default {
  name: 'Advertisement',

  mixins: [AjaxHelpersVue, ImagePreloaderVue],

  data() {
    return {
      advertisement: null,
      advertisementItems: null,
      advertisementItem: null,
      isBack: false,
      backLink: '',
      count: 0,
      perPage: 0,
      more: false,
      ps: null,
      ps2: null
    }
  },

  components: {
    SvgIcon
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadAdvertisementPage', params => {
      this.request(params.url);
    });

    EventBus.$on('loadAdvertisementPageInside', params => {
      this.requestInside(params);
    });
  },

  methods: {
    request(url) {
      let params = this.$route.params;

      this.req('AdvertisementPage:getAdvertisementPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.advertisement = res.content;
        }

        this.requestInside({params: params, url: this.$route.path});
      }, 'advertisement');
    },

    requestInside(params) {
      this.count = 0;
      let count = this.count;
      let itemId = params.params.itemId || '';
      let url = params.url || '';


      if(!this.advertisement) {
        this.request('/anonsy');
      }
      else {

        if(itemId.length && url !== '/anonsy') {
          this.requestAdvertisementItem(itemId);
        }
        else {
          if(!this.isBack) {
            this.backLink = url;

            this.$nextTick(() => {
              $('.advertisement__album').removeClass('advertisement__album--show');
            });

            this.req('AdvertisementPage:getAdvertisementPageItems', {count}, res => {
              if(this.checkProperty(res.content)) {
                this.advertisementItems = res.content;
                this.perPage = this.advertisementItems.items.length;
                this.more = res.content.more;
              }

              this.$nextTick(() => {
                this.imgPreloader('advertisement__item-img-wr', 'advertisement__item-img', '', 250);
                this.initScroll();
              });
            }, '', 'localPageRequest');
          }
          else {
            this.isBack = false;
          }
        }

      }
    },

    requestAdvertisementItem(itemId) {
      if(!this.advertisementItems) {
        this.requestInside({params: {}});
      }

      this.$nextTick(() => {
        $('.advertisement__card').addClass('advertisement__card--show');
        this.preloader('show');
      });

      this.req('AdvertisementPage:getAdvertisementPageItem', {itemId}, res => {
        if(this.checkProperty(res.content)) {
          this.advertisementItem = res.content;

          this.$nextTick(() => {
            this.imgPreloader('advertisement__card-img-wr', 'advertisement__card-img', '', 250);
            this.initScroll2();
            this.initFancy();
            this.preloader('hide');
          });
        }
      }, '', 'localPageRequest');
    },

    preloader(action) {
      let $preloader = $('.advertisement__card-preloader');

      if(action === 'show') {
        $preloader.removeClass('advertisement__card-preloader--hide')
            .addClass('advertisement__card-preloader--animation');
      }

      if(action === 'hide') {
        $preloader.addClass('advertisement__card-preloader--hide');

        setTimeout(() => {
          $preloader.removeClass('advertisement__card-preloader--animation');
        }, 500);
      }
    },

    goBack() {
      this.isBack = true;

      if(this.backLink) {
        this.$router.push({path: this.backLink});
      } else {
        var path = '/anonsy';

        this.$router.push({path: path});
      }

      this.$nextTick(() => {
        $('.advertisement__card').removeClass('advertisement__card--show');
      });
    },

    initFancy() {
      $('.advertisement__album').find('.advertisement__item').fancybox({
        image: {
          preload: true,
        },
        clickContent: function(current, event) {
          return current.type === "image" ? "zoom" : false;
        },
        dblclickContent: false,
        dblclickSlide: false,
        dblclickOutside: false,
        buttons: ['close'],
        infobar: false,
        hash: false
      });
    },

    initScroll() {
      if(this.ps === null) {
        this.ps = new PerfectScrollbar('.advertisement__content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      } else {
        const container = document.querySelector('.advertisement__content');
        container.scrollTop = 0;
        this.ps.update();
      }
    },

    initScroll2() {
      if(this.ps2 === null) {
        this.ps2 = new PerfectScrollbar('.advertisement__card-content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      } else {
        this.ps2.update();
      }
    },

    loadMoreItems() {
      this.count = this.count + this.perPage;
      let count = this.count;

      $('.advertisement__items-more').addClass('advertisement__items-more--loading');

      this.req('AdvertisementPage:getAdvertisementPageItems', {count}, res => {
        if(this.checkProperty(res.content)) {
          this.advertisementItems.items = this.advertisementItems.items.concat(res.content.items);
          this.more = res.content.more;
        }

        this.$nextTick(() => {
          this.imgPreloader('advertisement__item-img-wr', 'advertisement__item-img', '', 250);
          this.ps.update();

          setTimeout(() => {
            $('.advertisement__items-more').removeClass('advertisement__items-more--loading');
          }, 500);
        });
      }, '', 'localPageRequest');
    }

    /*popupLocal(type, action) {
      this.popup(type, action);
    }*/
  }

}
</script>
